@if (vendorNotDefined) {
  <div class="min-detail">Vendor Not Defined</div>
} @else {
  <div
    (click)="popOpen($event)"
    [style.cursor]="readOnly ? 'default' : 'pointer'"
    popovertarget="lvlPickerPopContent"
    popovertargetaction="show"
    class="min-detail"
  >
    @if (preloader) {
      <div><i nz-icon nzType="loading" nzTheme="outline"></i> Load Rate Levels...</div>
    } @else {
      @if ((rateLevels?.length ?? 0) > 0) {
        @if (define && currentLevelDetails?.id) {
          <div class="content">
            <div class="color" [style.backgroundColor]="currentLevelDetails?.color"></div>
            <div class="name">{{ currentLevelDetails?.name }}</div>
          </div>
        } @else {
          <div>Rate Level not Defined</div>
        }
      } @else {
        <div>No available Rate Levels</div>
      }
    }

    @if (showDetails && define && !preloader && !vendorNotDefined && currentLevelDetails) {
      <div class="details">
        @for (product of currentLevelDetails.products ?? []; track product; let i = $index) {
          <div
            class="product"
            [ngClass]="currentLevelDetails.products | checkRatesForMakeColumns: isUsrAdmin"
          >
            <!--HEADERS-->
            @if (i === 0) {
              <div class="head">Product</div>
            }
            @if (i === 0) {
              <div class="head">FIT Rate</div>
            }
            @if (isUsrAdmin && i === 0 && product.markup && product.serviceFee) {
              <div class="head">Markup</div>
            }
            @if (isUsrAdmin && i === 0 && product.markup && product.serviceFee) {
              <div class="head">Service Fee</div>
            }
            @if (
              ['col-3', 'col-5'].indexOf(
                currentLevelDetails.products | checkRatesForMakeColumns: isUsrAdmin
              ) >= 0 && i === 0
            ) {
              <div class="head">Retail Rate</div>
            }
            <!--Product Name-->
            <div *ngTemplateOutlet="pd; context: { product: product }"></div>
          </div>
        }
      </div>
    }
  </div>
}

<!--popover content-->
<div #lvlPickerPopContent popover class="my-pop-over">
  <div class="header">Select Rate Level</div>
  <div class="scroll">
    @for (lvl of rateLevels ?? []; track lvl) {
      <div
        class="content menu"
        (click)="popSet(lvl); visible = false"
        [ngClass]="{ current: currentLevelDetails.id === lvl.id }"
      >
        <div class="color" [style]="{ backgroundColor: lvl.color }"></div>
        <div class="name">
          {{ lvl.name }}
          <div class="descr">
            {{ lvl.description }}
          </div>
        </div>
        <div class="details">
          <div
            class="product"
            [ngClass]="currentLevelDetails?.products | checkRatesForMakeColumns: isUsrAdmin"
          >
            <!--HEADERS-->
            <div class="head">Product</div>
            <div class="head">FIT Rate</div>
            @if (
              ['col-4', 'col-5'].indexOf(
                currentLevelDetails?.products | checkRatesForMakeColumns: isUsrAdmin
              ) >= 0
            ) {
              <div class="head">Markup</div>
              <div class="head">Service Fee</div>
            }
            @if (
              ['col-3', 'col-5'].indexOf(
                currentLevelDetails?.products | checkRatesForMakeColumns: isUsrAdmin
              ) >= 0
            ) {
              <div class="head">Retail Rate</div>
            }
            <div *ngTemplateOutlet="pd; context: { product: lvl.minRate, hd: true }"></div>
            @if (lvl.minRate?.productId !== lvl.maxRate?.productId) {
              <div *ngTemplateOutlet="pd; context: { product: lvl.maxRate, hd: true }"></div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

<!--NG-TAMPLATE for Display Product Details-->
<ng-template #pd let-product="product" let-hd="hd">
  <div class="name">
    <div style="font-weight: 600">
      {{ product.details?.name?.value }}
    </div>
    @if (product?.details?.description && !hd) {
      <div style="color: #00000094; font-weight: 300">
        {{ product.details.description }}
      </div>
    }
  </div>

  <!--For Admin-->
  @if (isUsrAdmin) {
    <div class="rate">
      {{ product.fit.total | currency }}
    </div>

    @if (
      ['col-4', 'col-5'].indexOf(
        currentLevelDetails?.products | checkRatesForMakeColumns: isUsrAdmin
      ) >= 0
    ) {
      <div class="rate">
        @if (product.markup && product.serviceFee) {
          @if (product.markup.type === 'PERCENT') {
            <span>{{ product.markup.value }}%</span>
          } @else {
            <span>{{ product.markup.value | currency }}</span>
          }
        } @else {
          ---
        }
      </div>

      <div class="rate">
        @if (product.markup && product.serviceFee) {
          @if (product.serviceFee.type === 'PERCENT') {
            <span>{{ product.serviceFee.value }}%</span>
          } @else {
            <span>{{ product.serviceFee.value | currency }}</span>
          }
        } @else {
          ---
        }
      </div>
    }

    @if (
      ['col-3', 'col-5'].indexOf(
        currentLevelDetails?.products | checkRatesForMakeColumns: isUsrAdmin
      ) >= 0
    ) {
      <div class="rate">
        {{ product.retail.total | currency }}
      </div>
    }
  } @else {
    <!--For User-->
    <div class="rate">
      {{ product.fit.total | currency }}
    </div>
    <div class="rate">
      {{ product.retail.total | currency }}
    </div>
  }
</ng-template>
